import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Location">
                {/*<h1>TekRevol Location</h1>*/}
                <h1>Empowering Businesses Worldwide With Innovation</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  Tekrevol is a global technology and digital solutions provider
                  that has built a strong presence across multiple continents.
                  We have established ourselves as a leader in the industry by
                  offering innovative digital products and services to clients
                  worldwide.
                </p>
                <ul>
                  <li>Global Technology Partner</li>
                  <li>Strategic Office Locations</li>
                  <li>Worldwide Digital Solutions</li>
                  <li>Diverse Regional Footprint</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
